









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import authService from './authentication/authentication.service';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { CHANGE_WORKSPACE } from '@/store/app/actionTypes';
import {workspacesApi} from '@/workspaces/workspaces';
import {ConnectClaim} from '@/authentication/claims';
import {config} from '@/config/config';
import connectWidget from '@/connect/connectWidget';
import { ATTENDANT_TRIAGE_FLOWS_ENABLED } from '@/store/app/featureTypes';

@Component
export default class App extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public workspaces!: WorkspaceViewModel[];
	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;

	public activeRoute: string = '';

	@Action(CHANGE_WORKSPACE) public changeWorkspace: any;

	@Watch('$route', { immediate: true })
	public onRoute(to: any) {
		this.activeRoute = to.name ?? '';
	}

	public get botsLandingPage() {
		return this.isWorkspaceFeatureEnabled(ATTENDANT_TRIAGE_FLOWS_ENABLED) ? '/bots/tasks' : '/bots/flows';
	}

	public async mounted() {
		await this.addConnectWidget();
		await this.setupRouteHooks();
	}

	public logout() {
		authService.logout();
	}

	public isAuthenticated() {
		return authService.isAuthenticated();
	}

	public getUserName() {
		return authService.getUserName();
	}

	public selectWorkspace(workspace: WorkspaceViewModel) {
		this.changeWorkspace(workspace);
	}

	public goToSettings() {
		this.$router.push({name: 'general-settings'});
	}

	public isPageThatAllowsUnauthenticatedAccess() {
		return this.activeRoute.startsWith('register') || this.activeRoute.startsWith('twitter-auth');
	}

	private async getUserCredentials() {
		if (config().webAssistantWorkspaceId && this.isAuthenticated()) {
			const token = await workspacesApi.createUserTokenForConnect();
			const userId = authService.getClaim(ConnectClaim.UserId);
			return {token, userId};
		}
	}

	private async addConnectWidget(): Promise<void> {
		const userCredentials = await this.getUserCredentials();
		if (userCredentials) {
			connectWidget.addWebAssistant(userCredentials.userId, userCredentials.token);
		}
	}

	private async setupRouteHooks() {
		this.$router.afterEach(() => {
			this.$nextTick
			(async () => {
				const userCredentials = await this.getUserCredentials();
				if (userCredentials) {
					await connectWidget.update(userCredentials.userId, userCredentials.token);
				}
			});
		});
	}
}
